/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Test_Desc4Inputs */

const en_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified against Claude, ChatGPT and Cursor before docs ship.`)
};

const ar_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التحقق مع Claude وChatGPT وCursor قبل نشر التوثيق.`)
};

const bn_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডক আসার আগেই Claude, ChatGPT আর Cursor-এ যাচাই করা।`)
};

const de_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziert gegen Claude, ChatGPT und Cursor, bevor die Dokumentation erscheint.`)
};

const es_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado con Claude, ChatGPT y Cursor antes de publicar la documentación.`)
};

const fr_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifié contre Claude, ChatGPT et Cursor avant de publier la documentation.`)
};

const pt_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado com Claude, ChatGPT e Cursor antes de publicar a documentação.`)
};

const zh_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档发布前，先在 Claude、ChatGPT 和 Cursor 上验证通过。`)
};

const tr_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeler çıkmadan Claude, ChatGPT ve Cursor ile doğrulandı.`)
};

const ru_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверено против Claude, ChatGPT и Cursor до выхода документации.`)
};

const pl_svc_mcp_server_development_test_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowane przeciw Claude, ChatGPT i Cursorowi, zanim wyjdzie dokumentacja.`)
};

/**
* | output |
* | --- |
* | "Verified against Claude, ChatGPT and Cursor before docs ship." |
*
* @param {Svc_Mcp_Server_Development_Test_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_test_desc4 = /** @type {((inputs?: Svc_Mcp_Server_Development_Test_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Test_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "de") return de_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "es") return es_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_test_desc4(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_test_desc4(inputs)
	return en_svc_mcp_server_development_test_desc4(inputs)
});
export { svc_mcp_server_development_test_desc4 as "svc_mcp-server-development_TEST_desc" }